import React, { useState } from "react";
import OfferFlight from "../hotel/OfferFlight";
import OneWayFlightOffer from "./OneWayFlightOffer";
import { useSelector, useDispatch } from "react-redux";
import LoadBar from "../components/LoadBar";
import FlightVerificationButton from "./FlightVerificationButton";
import FlightIataFilter from "../filters/FlightIataFilter";

export default function FlightsView(props) {
  const { searchFrame } = props;
  const fares = useSelector((state) => state.flight.fares);
  const offers = useSelector((state) => state.flight.offers);
  const loading = useSelector((state) => state.system.loading);
  const oneway = useSelector((state) => state.search.oneway);
  const [baggage, setBaggage] = useState(false);
  const [filterAirlines, setFilterAirlines] = useState([]);

  let evenflight = false;

  return (
    <div className="flightview">
      {searchFrame}
      <LoadBar
        offers={[]}
        view={"flights"}
        text={
          "test"
          /*searchEnded &&
          Array.isArray(offers) &&
          offers.length > 0 &&
          Array.isArray(offers[0].MarketingActions) &&
          offers[0].MarketingActions.length > 0 &&
          offers[0].MarketingActions[0].checkinfo
            ? offers[0].MarketingActions[0].checkinfo
            : "suche beste Hotelangebote" + searchcity*/
        }
      />
      <div style={{ display: "flex" }}>
        <div className="offerview2">
          {/*<button onClick={() => console.log(filterAirlines)}>debug</button>*/}
          <FlightIataFilter
            setBaggage={setBaggage}
            baggage={baggage}
            filterAirlines={filterAirlines}
            setFilterAirlines={setFilterAirlines}
          ></FlightIataFilter>
        </div>
        <div style={{ width: "100%" }}>
          {offers.length > 0 && (
            <>
              {offers
                .filter((o) => {
                  return (
                    (!baggage ||
                      (baggage &&
                        o.bookinginfo?.Offer?.Package?.Flight
                          ?.OutboundFlightSegments?.FlightSegment[0]
                          ?.BaggageAllowance?.value != "0PC" &&
                        o.bookinginfo?.Offer?.Package?.Flight
                          ?.OutboundFlightSegments?.FlightSegment[0]
                          ?.BaggageAllowance?.value != "0K")) &&
                    (filterAirlines.length == 0 ||
                      filterAirlines.includes(
                        o.OfferServices?.Package?.Flight?.OutboundFlight
                          ?.Airline?.AirlineCode
                      ))
                  );
                })
                .map((o, i) => {
                  evenflight = !evenflight;
                  let stationstmp = { Station: [] };
                  stationstmp.Station.push({
                    StationCode:
                      o?.OfferServices?.Package?.Flight?.OutboundFlight
                        ?.FlightArrival?.ArrivalAirportRef?.AirportCode,
                    Name: o?.bookinginfo?.Offer?.Package?.Flight
                      ?.OutboundFlightSegments?.DestinationAirport?._,
                  });
                  stationstmp.Station.push({
                    StationCode:
                      o?.OfferServices?.Package?.Flight?.OutboundFlight
                        ?.FlightDeparture?.DepartureAirportRef?.AirportCode,
                    Name: o?.bookinginfo?.Offer?.Package?.Flight
                      ?.OutboundFlightSegments?.DepartureAirport?._,
                  });
                  //console.log(stationstmp);

                  return (
                    <>
                      {
                        <div
                          key={"flight-" + i}
                          className={
                            evenflight ? "offerflightrow1" : "offerflightrow2"
                          }
                          style={{
                            display: "flex",
                            padding: 8,
                          }}
                        >
                          {oneway ? (
                            <OneWayFlightOffer
                              verbose={true}
                              offer={o}
                              stations={stationstmp}
                              horizontal={true}
                            ></OneWayFlightOffer>
                          ) : (
                            <OfferFlight
                              verbose={true}
                              offer={o}
                              stations={stationstmp}
                              horizontal={true}
                            ></OfferFlight>
                          )}{" "}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-end",
                            }}
                          >
                            <FlightVerificationButton></FlightVerificationButton>
                          </div>
                        </div>
                      }
                    </>
                  );
                })}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
